<template>
  <LoaderItem v-if="loading"></LoaderItem>

  <div class="container-fluid">
    <div class="row">

      <div class="d-none d-md-block col-md-7 image_container"></div>

      <div class="col-md-5 col-sm-12">
        <div class="row">
          <div class="col-md-12 col-sm-12 d-flex right_side">
            <div class="d-flex login_container">
              <div class="login_logo_wrapper">
              </div>

              <Form @submit="handleLogin" :validation-schema="schema">
                <div class="error-feedback red-color" v-if="this.message">
                  {{this.message}}
                </div>
                <div class="input-group">
                  <span class="input-group-text" id="basic-addon1" style="margin: auto">
                       <img src="/svgs/user.svg" >
                  </span>
                  <Field type="text" id="nickname" name="nickname" value="" class="form-control input" placeholder="სახელი"  autocomplete="nickname" autofocus="" />
                </div>
                <ErrorMessage name="nickname" class="error-feedback invalid-feedback" />
                <div class="input-group">
                <span class="input-group-text" id="basic-addon2" style="margin: auto">
                   <img src="/svgs/password.svg" >
                </span>
                <Field :type="this.passwordInputType" id="password" name="password" placeholder="პაროლი" value="" class="form-control input" />
                 <span class="input-group-text" id="eye-addon" style="margin:  auto">
                    <img :src="'/svgs/'+this.eyeIcon" @click="changeEyeImage()">
                </span>
                </div>
                <ErrorMessage name="password" class="error-feedback invalid-feedback" />

                <div class="form-check">
                 <div>
                   <input type="checkbox" id="remember" value="" class="form-check-input">
                   <label class="form-check-label" for="remember">დამახსოვრება </label>
                 </div>
                  <a href="" class="reset-password">დაგავიწყდა პაროლი</a>
                </div>
                <button class="btn btn-primary login_button form-control">შესვლა</button>
              </Form>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
import { Form, Field, ErrorMessage } from 'vee-validate'
import * as yup from 'yup'
import EventBus from "@/common/EventBus";

export default {
  name: "LoginItem",
  components: {
    Form,Field,ErrorMessage
  },
  data() {
    const schema = yup.object().shape({
      nickname: yup.string().required("სავალდებულო ველი"),
      password: yup.string().required("სავალდებულო ველი"),
    });
    return {
      loading: true,
      message: "",
      eyeIcon: 'close-eye.svg',
      passwordInputType: 'password',
      schema
    }
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status ? this.$store.state.auth.status.loggedIn : null
    }
  },
  created() {
    if (this.$route.query.sid){
      const rot = this.$router
      this.$store.dispatch('auth/loginWithToken', this.$route.query.sid).then(

          setTimeout(function (){
            rot.push('/')
          },300)
      )
    }


    if (this.loggedIn) {
      this.$router.push('/')
    }
  },

  methods: {
    changeEyeImage(){
      if (this.eyeIcon === "close-eye.svg"){
        this.eyeIcon = "open-eyes.svg"
        this.passwordInputType = "text"
      }else{
        this.eyeIcon = "close-eye.svg"
        this.passwordInputType = "password"
      }
    },
    handleLogin(user) {
      this.loading = true;
      this.$store.dispatch('auth/login', user).then(
          () => {
            this.$store.state.alert.alertCount = null
            this.$router.push('/')
            this.message = ''
          },
          (error) => {
            this.loading = false
            // this.message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            this.message = "მომხარებლის სახელი ან პაროლი არასწორია"
            if (error.response && error.response.status === 403) {
              EventBus.dispatch("logout");
            }
          }
      )
    }
  }
}

</script>

<style scoped>

.right_side{
  box-shadow: none;
}

.image_container{
  background: url("../../public/img/warehouse.jpg") no-repeat center center ;
  background-size: cover;
  height: 100vh;
}

.right_side{
  font-family: "TBCDinNusxuri-Medium";
  width: 100%;
  align-items: center;
  height: 100vh;
}

.login_container{
  width: 100%;
  height: 400px;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.login_container form{
  padding-top: 25px;
  width: 368px;
}

.login_container form .input-group{
  margin-top: 20px;
  border-radius: 5px;
  height: 45px;

}
.login_container form .input-group, .input{
  background-color: var(--input-main-bg);
}

.login_container form .form-check{
  display: flex;
  justify-content: space-between;
  margin-top:20px;
}
.login_container form button{
  margin-top:20px;
  height: 45px;
}

.login_logo_wrapper{
  background: url("../../public/img/tempohub_logo.png") no-repeat center center;
  background-size: cover;
  width: 336px;
  height: 76px;
}

.login_button{
  border-radius: 5px;
  background-color: var(--main-bg);
  border: 0 var(--main-bg);
}

.login_button:hover, .login_button:active, .login_button:focus{
  background-color: var(--main-bg) !important;
  border: 0 var(--main-bg);
  outline: 0 !important;
  box-shadow: none !important;
}

.input-group-text{
  background-color: transparent;
}

.input-group-text{
  border: 0;
}

.input{
  border: 0;
}

.input:not(:last-child){
  border-right: 0;
}

.input:hover, .input:active, .input:focus{
  box-shadow: none !important;
}

.form-control:focus{
  background-color: transparent;
}

.form-check-label{
  color: var(--text-sub-color);
}

.reset-password{
  color: var(--text-sub-bold-color);
  text-decoration: none;
}

.reset-password:hover{
  color: var(--text-sub-bold-color);
  text-decoration: none;
}

.error-feedback{
  display: block;
  float: left;
  text-align: left;
}

@media only screen and (max-width: 899px)  {

  .form-check-label, .reset-password{
    font-size:14px;
  }
  .login_logo_wrapper{
    background-size: contain;
    width: 310px;
    height: 70px;
  }

  .input-group-text:not(.week-groups .input-group-text):not(.input-group-text.exclude-this){
    padding:5px;
  }
  .input-group-text img{
    margin-left: 10px;
    margin-right: 10px;
  }

  .login_container{
    justify-content: flex-start;
    margin-bottom: 25%;
  }
  .login_container form{
    padding-top: 10px;
    width: 320px;
  }

}


</style>